<div id="content">
  <div class="page-title">
    <h1>Workspaces</h1>
  </div>

  <div class="bisual-table">
    <form class="card paginator" [formGroup]="filterForm">
      <mat-paginator
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="pageIndex"
        (page)="changePage($event)"
        style="margin-right: auto"
      ></mat-paginator>

      <mat-form-field appearance="outline">
        <mat-label>Provider</mat-label>
        <mat-select formControlName="provider" (selectionChange)="pageIndex = 0; fetchData()">
          <mat-option value="">Todos</mat-option>
          <mat-option value="slack">Slack</mat-option>
          <mat-option value="teams">Teams</mat-option>
          <mat-option value="google_chat">Google Chat</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Estado</mat-label>
        <mat-select formControlName="status" (selectionChange)="pageIndex = 0; fetchData()">
          <mat-option value="pending">Pendientes de empresa</mat-option>
          <mat-option value="ignored">Omitidos</mat-option>
          <mat-option value="all">Todos</mat-option>
        </mat-select>
      </mat-form-field>
    </form>

    <div class="bisual-table-container">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="provider">
          <th mat-header-cell *matHeaderCellDef>Provider</th>
          <td mat-cell *matCellDef="let row">{{ row.provider_label }}</td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Nombre</th>
          <td mat-cell *matCellDef="let row">{{ row.name }}</td>
        </ng-container>

        <ng-container matColumnDef="external_id">
          <th mat-header-cell *matHeaderCellDef>ID externo</th>
          <td mat-cell *matCellDef="let row">{{ row.external_id }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Estado</th>
          <td mat-cell *matCellDef="let row">{{ row.status_label }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            @if (row.is_pending) {
              <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item type="button" (click)="assignCompany(row)">
                  <mat-icon>business</mat-icon>
                  <span>Asociar empresa</span>
                </button>
                <button mat-menu-item type="button" (click)="ignore(row)">
                  <mat-icon>visibility_off</mat-icon>
                  <span>Omitir</span>
                </button>
              </mat-menu>
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</div>
